export default __webpack_public_path__ + "static/DINosaurKU-Light-e0c83dc13b40ec7713751d7f2230a322.woff2";